module.exports = __webpack_public_path__ + "static/media/computer.a277703e.jpg";